<template>
  <section>
    <Modal
      :title="
        payloadData.isLoading
          ? 'Payload Inspector'
          : 'Payload Inspector (' +
            payloadData.data.payload_transmission.upstream_dev_id +
            ')'
      "
      :background-primary="true"
      @close="$parent.close()"
    >
      <div class="is-payloadinspector-modal">
        <div class="modal-card is-page-modal">
          <b-loading
            :is-full-page="false"
            :active.sync="payloadData.isLoading"
            :can-cancel="false"
          />
          <b-table
            ref="payload-table"
            class="is-payload-table"
            :data="payloadData.isLoading ? [] : [payloadData.data.payload]"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="false"
            :loading="false"
            :focusable="false"
            :mobile-cards="false"
          >
            <template slot-scope="props">
              <b-table-column
                v-for="key in Object.keys(props.row)"
                :key="key"
                :field="key"
                :label="key"
              >
                {{ props.row[key] }}
              </b-table-column>
            </template>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon
                      icon="stream"
                      pack="fas"
                      size="is-large"
                    />
                  </p>
                  <p>Payload unavailable.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </div>
    </Modal>
  </section>
</template>

<script>
import Modal from "@/components/elements/Modal.vue";

export default {
  name: "PayloadInspector",
  components: {
    Modal,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      payloadData: {
        data: this.data,
        isEmpty: typeof this.data == "undefined",
        isLoading: false,
      },
    };
  },
  methods: {},
};
</script>

<style lang="scss">
.is-payload-table {
  margin-left: 1rem;
  margin-right: 1rem;
}

.is-payloadinspector-modal {
  min-height: 8rem;
  height: auto;
  min-width: 50rem;
  width: auto;
  overflow-y: auto;
}
</style>